import { Injectable } from '@angular/core';
import { categoryData, specialInfoData, typeData } from '../../../interfaces/selectData';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  categoryData = categoryData;
  typeData = typeData;


  constructor() { }


  getCategoryIcon(categoryValue: string): string | null {
    const category = this.categoryData.find(item => item.text === categoryValue);
    return category ? category.icon : null;
  }

  getExportCategoryIcon(categoryValue: string): string | null {
    const category = this.categoryData.find(item => item.text === categoryValue);
    return category ? category.exportName : null;
  }


  getTypeIcon(typeValue: string): string | null {
    //console.log(typeValue)
    const type = this.typeData.find(item => item.type === typeValue);
    //console.log(type)
    return type ? type.icon : null;
  }

  getExportTypeIcon(typeValue: string): string | null {
    //console.log(typeValue)
    const type = this.typeData.find(item => item.type === typeValue);
    //console.log(type)
    return type ? type.exportName : null;
  }


  getIconUrl(iconName: string): string {
    return `https://assets.tridimo.de/fontawesome/svgs/regular/${iconName}.svg`;
  }


specialIconData = specialInfoData;

    getExportIcon(iconName: string): string |null {
   
        const icon = this.specialIconData.find(item => item.icon_name === iconName);

    return icon ? icon.exportName : null;
  }


  getIconTitle(iconName: string) {
    if(iconName === 'camera') {
      return 'Social Media Video'
    } else if (iconName === 'mars') {
      return 'm'
    } else if (iconName === 'venus') {
      return 'w'
    } else if (iconName === 'circle-info') {
      return 'Wichtig'
    } else if (iconName === 'registered') {
      return 'angemeldeter Dolmetscher'
    } else if (iconName === 'circle-dollar') {
      return 'genannte Dolmetscher'
    } else if (iconName === 'circle-plus') {
      return 'Dolmetscher gewünscht'
    } else if (iconName === 'circle-minus') {
      return 'Dolmetscher ungewünscht'
    } else if (iconName === 'user-circle-plus') {
      return 'Feste Dolmetscher'
    } 
    return ''
  }


  getIconBackground(event: any, icon: string){
    
    const evt = event.original || event;

    if(icon === 'online'){
      const { online, onlineLink } = evt;

      if (online === 1) {
        let parsed: { platform: string; link: string }[] = [];

        if (onlineLink) {
          if (typeof onlineLink === 'string') {
            try {
              const temp = JSON.parse(onlineLink);
              parsed = Array.isArray(temp) ? temp : [temp];
            } catch {
              parsed = [];
            }
          } else if (Array.isArray(onlineLink)) {
            parsed = onlineLink;
          } else if (typeof onlineLink === 'object') {
            parsed = [onlineLink];
          }
        }

        if (parsed.length === 0) {
          return '#FCAF19'
        } 

        const allValid = parsed.every(
          ({ platform, link }: { platform: string; link: string }) =>
            platform === 'apple' || platform ==='Keine Plattform' || platform === 'studio'
              // fbc: platform reicht, link egal / darf leer sein
              ? true
              // alle anderen: platform UND link müssen gesetzt sein
              : platform?.trim() !== '' && link?.trim() !== ''
        );

        return allValid ? '#91c15a' : '#FCAF19';
      }

      return;

    }else if(icon === 'interpretor'){
      return '#FCAF19';
    }else if(icon === 'location'){
      
      if(evt.location === ''){
        return '#FCAF19';
      }
      else if(evt.location !== '' && evt.calculateTraveltime){
        return '#91c15a'
      }
      
    }else{
      return '#FCAF19';
    }
    return;
  }

  
  getPrepIconBackground(event: any){

    const source = event?.original ?? event;

    const {
      vorbereitungsmaterial,
      vorbereitungsmaterialLink
    } = source;
  
      if (vorbereitungsmaterial === '1' || vorbereitungsmaterial === true) {
        if (vorbereitungsmaterialLink && vorbereitungsmaterialLink.trim() !== '') {
          return '#91c15a';
        } else {
          return '#FCAF19';
        }
      }
      return
  }
}
